import { render, staticRenderFns } from "./TaskListEmptyState.vue?vue&type=template&id=3f38f390"
import script from "./TaskListEmptyState.vue?vue&type=script&lang=js"
export * from "./TaskListEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports